import { Card } from './Card';

export type { TypeCardProps } from './types';
export default Card;
